import type { IUserInfo } from "#src/services/auth";
import { IWorkspaceItem } from "#src/services/workspace";
import { type PayloadAction, createSlice } from "@reduxjs/toolkit";

interface IAuthState {
  userInfo: IUserInfo | undefined;
  currentWorkspace: IWorkspaceItem | undefined;
}

const initialState: IAuthState = {
  userInfo: undefined,
  currentWorkspace: undefined,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    updateUserInfo: (state, action: PayloadAction<IUserInfo>) => ({
      ...state,
      userInfo: action.payload,
    }),
    updateCurrentWorkspaceV2: (
      state,
      action: PayloadAction<IWorkspaceItem>
    ) => ({
      ...state,
      currentWorkspace: action.payload,
    }),
  },
});

export const { updateUserInfo, updateCurrentWorkspaceV2 } = authSlice.actions;

export const authReducer = authSlice.reducer;
